module.exports = __webpack_public_path__ + "static/assets/77b3b9481f1277a47dece91e8d9fb104.ttf";